module.exports = __webpack_public_path__ + "img/worldOfMusic.d220fef6.png";